import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { postTrianerLeaveApply } from '../../assets/nodeApi/postApi/postCommonApi';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TextFormField } from '../../shared/components/formfields/TextFormField';
import { Grid_Gap, Input_Width } from '../../shared/constants';
import { Button, Grid2, Typography } from '@mui/material';
import { useToaster } from '../../shared/utils/ToasterProvider';
import { DateFormField } from '../../shared/components/formfields/DataFormField';
import CustomDivider from '../../shared/utils/CustomDivider';
import { useGetAllTrainerLeaves } from '../../assets/nodeApi/getApi/getCommonApi';
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate';
import { getFormattedDateTable } from '../../shared/formatter';

const CommonRaisLeave = () => {
    const queryClient=useQueryClient()
    const { data: allTrainerLeaves, isLoading: isTrainerLeaveListLoading } = useGetAllTrainerLeaves()
    const { showToaster } = useToaster();


    const initialValues = {
        start_date: '',
        end_date: '',
        reason: '',
    };

    const validationSchema = Yup.object({
        start_date: Yup.date()
            .required('Start date is required'),
        end_date: Yup.date()
            .required('End date is required'),
        reason: Yup.string()
            .required('Reason is required')
    });

    const mutation = useMutation({
        mutationFn: postTrianerLeaveApply,

    });

    const handleSubmit = (values, { resetForm }) => {
        mutation.mutate(values, {
            onSuccess: (res) => {
                const message = res?.message || 'Leave requested successfully!';
                showToaster(message, '', 'success');
             queryClient.invalidateQueries({ queryKey: ['trainer-leaves/trainer'] });
                resetForm();

            },
            onError: (err) => {
                const errorMessage =
                    err?.response?.data?.message ||
                    err?.response?.data?.error ||
                    'Failed to request leave';
                showToaster(errorMessage, '', 'error');
            },
        });
    };


    const leaveRequestRow =
        allTrainerLeaves?.data?.map((item, index) => ({
            sr_no: index + 1,
            ...item
        })) ?? [];
    const leaveRequestColumns = [
        {
            field: "sr_no",
            headerName: "Sr No",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>
        },
        {
            field: "start_date",
            headerName: "Start Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{getFormattedDateTable(params.value)}</Typography>,
        },
        {
            field: "end_date",
            headerName: "End Date",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{getFormattedDateTable(params.value)}</Typography>,
        },
        {
            field: "total_days",
            headerName: "Total Days",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "reason",
            headerName: "Reason",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "status",
            headerName: "Status",
            flex: 1,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
    ];
    return (
        <>
            <NormalContainerWithHeader headerText={"Request Leave"}>
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                    {({ values, resetForm }) => (
                        <Form>
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="start_date"
                                        component={DateFormField}
                                        label="Start Date"
                                        isRequired={true}
                                        minDate={new Date()}
                                        maxDate={values.end_date || undefined}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="end_date"
                                        component={DateFormField}
                                        label="End Date"
                                        isRequired={true}
                                        minDate={values.start_date || new Date()}
                                    />
                                </Grid2>
                                <Grid2 children size={Input_Width}>
                                    <Field
                                        name="reason"
                                        component={TextFormField}
                                        label="Reason"
                                        isRequired={true}

                                    />
                                </Grid2>

                            </Grid2>
                            <CustomDivider />
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 children textAlign={"end"} size={Input_Width}>
                                    <Button variant='outlined' fullWidth onClick={resetForm}>
                                        Reset
                                    </Button>
                                </Grid2>
                                <Grid2 children textAlign={"end"} size={Input_Width}>
                                    <Button variant='contained' type='submit' fullWidth disabled={mutation.isPending}>
                                        {mutation?.isPending ? "Submitting" : "Submit"}
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>
            </NormalContainerWithHeader>
            <CustomDivider />
            <TableFilterTemplate
                title="Your Requested Leaves"
                columns={leaveRequestColumns}
                rowsData={leaveRequestRow}
                isLoading={isTrainerLeaveListLoading}
            // renderFilterFields={() => <></>}
            />

        </>
    )
}

export default CommonRaisLeave
